<template>
  <div>
    <div class="split-box">
      <div class="split-line"></div>
      <div class="split-name">【采购报告状态修改】</div>
    </div>
    <div class="view-row">
      <div class="view-field">
        <div class="view-label" style="line-height: 40px">项目状态</div>
        <div class="view-val">
          <el-select v-model="status" :clearable="true" placeholder="请选择">
            <el-option v-for="item in pro_report_StatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div style="padding-left: 20px; display: inline-block">
            <el-button type="primary" @click="updateProjectjjbgstatus">保存</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "PurchaseReportStatus",
  data() {
    return {
      pro_report_StatusList: [
        { value: "1", label: "待提交" },
        { value: "2", label: "待审核" },
        { value: "3", label: "同意" },
        { value: "4", label: "不同意" },
      ],
      status: this.projectjjbgstatus
    };
  },
  props: ['projectjjbgstatus', 'projectid'],
  watch: {
    projectjjbgstatus(nval, oval) {
      this.status = nval
    }
  },
  methods: {
    async updateProjectjjbgstatus() {
      this.$confirm("是否确定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let res = await request({
            url: "/xtgl/status/updateProjectjjbgstatus",
            method: "post",
            data: {
              projectid: this.projectid,
              projectjjbgstatus: this.status,
            },
          });
          if (+res.issuccess === 1) {
            this.$message.success("更新成功");
            this.getModel();
          }
          this.loading = false;
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.split-box {
  margin: 11px 0 15px;

  .split-line {
    margin: 5px;
  }

  .split-name {
    font-weight: bold;
  }
}
</style>
